/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S11_P1Inputs */

const tr_kullanim_s11_p1 = /** @type {(inputs: Kullanim_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri İçeriği (ürün, sipariş, müşteri kaydı, fatura verisi ve Platform aracılığıyla işlenen diğer tüm veriler) Müşteri'ye aittir. Sağlayıcı yalnızca veri işleyen sıfatıyla hareket eder ve Müşteri İçeriği'ni Abonelik süresince Müşteri talimatları doğrultusunda işler.`)
};

const en_kullanim_s11_p1 = /** @type {(inputs: Kullanim_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Customer Content (product, order, customer record and invoice data and all other data processed through the Platform) belongs to the Customer. The Provider acts solely as a data processor and processes the Customer Content in line with the Customer's instructions for the duration of the Subscription.`)
};

const de_kullanim_s11_p1 = /** @type {(inputs: Kullanim_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Kundeninhalte (Produkt-, Bestell-, Kundendatensatz- und Rechnungsdaten sowie alle sonstigen über die Plattform verarbeiteten Daten) gehören dem Kunden. Der Anbieter handelt ausschließlich als Auftragsverarbeiter und verarbeitet die Kundeninhalte während der Laufzeit des Abonnements nach den Weisungen des Kunden.`)
};

const ru_kullanim_s11_p1 = /** @type {(inputs: Kullanim_S11_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент клиента (данные о товарах, заказах, записи о клиентах, данные счетов и все прочие данные, обрабатываемые через Платформу) принадлежит Клиенту. Поставщик выступает исключительно обработчиком данных и обрабатывает Контент клиента в течение срока Подписки в соответствии с указаниями Клиента.`)
};

/**
* | output |
* | --- |
* | "The Customer Content (product, order, customer record and invoice data and all other data processed through the Platform) belongs to the Customer. The Provid..." |
*
* @param {Kullanim_S11_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s11_p1 = /** @type {((inputs?: Kullanim_S11_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S11_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s11_p1(inputs)
	if (locale === "de") return de_kullanim_s11_p1(inputs)
	if (locale === "ru") return ru_kullanim_s11_p1(inputs)
	return tr_kullanim_s11_p1(inputs)
});